import React, { useState } from "react";
import { Link } from "react-router-dom";

const CategoryCard = ({ title, image, link }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Link to={link} className="block w-full h-full">
            <div
                className="relative w-[260px] h-[300px] mx-auto group"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>

                <div className={`w-full h-[300px] bg-center bg-cover rounded-xl transition-transform duration-500 ease-in-out ${ isHovered ? "scale-110" : "scale-100"}`}
                    style={{
                        backgroundImage: `url(${image})`,
                    }}
                ></div>

                <div className={`flex items-center h-[80px] pl-2 transition-transform duration-500 ease-in-out ${ isHovered ? "scale-105" : "scale-100" }`}>
                    <h3 className="text-[18px] sm:text-[20px] font-semibold text-[#41220E] font-montserrat">
                        {title}
                    </h3>
                </div>
            </div>
        </Link>
    );
};

export default CategoryCard;
